import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export const UserAvatar = ({
  displayName,
  photoUrl,
  email,
  full,
  half,
}: any): any => {
  return (
    <div className="flex items-center space-x-3 text-foreground">
      <Avatar className="w-8 h-8">
        <AvatarImage src={photoUrl} />
        <AvatarFallback>
          {displayName?.length > 0 ? displayName[0] : ""}
        </AvatarFallback>
      </Avatar>
      {(full || half) && (
        <div className="flex flex-col">
          <span className="text-sm font-medium text-ellipsis">
            {displayName?.length > 0 ? displayName?.split(" ")[0] : ""}
          </span>
          {!half && (
            <span className="text-sm text-muted-foreground">{email}</span>
          )}
        </div>
      )}
    </div>
  );
};
